import { l } from '@manychat/manyui'

import { KnowledgeErrorCode } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export const getErrorContent = (
  code: KnowledgeErrorCode | null,
): { title: string; description: string } | null => {
  switch (code) {
    case KnowledgeErrorCode.PARSING_ERROR: {
      return {
        title: l.translate('Can’t read this link'),
        description: l.translate(
          'This URL is unavailable or unreadable. <l10n context="Try again, use a different link or learn how to fix this"/>Try again, use a different link or ',
        ),
      }
    }
    case KnowledgeErrorCode.BLACK_LISTED_DOMAIN: {
      return {
        title: l.translate('Link can’t be used'),
        description: l.translate(
          "This domain can't be accessed. <l10n context='Try a different link or learn how to fix this'/>Try a different link or ",
        ),
      }
    }
    case KnowledgeErrorCode.INTERNAL_ERROR: {
      return {
        title: l.translate("Couldn't process this link"),
        description: l.translate(
          'Something went wrong. <l10n context="Try again, use a different link or learn how to fix this"/>Try again, use a different link or ',
        ),
      }
    }
    default:
      return null
  }
}
